import CaseContentInfoBarchiveItem from "./Item";

const CaseContentInfoBarchive = ({ bayganis, ...props }) => {
  return (
    <div className="flex flex-col gap-7">
      <h2 className="font-medium text-gray-700 text-lg"> {props.title} </h2>

      {bayganis && bayganis.length >= 1 ? (
        <ul className="grid sm:grid-cols-2 grid-cols-1 gap-4">
          {bayganis.map((item, index) => (
            <CaseContentInfoBarchiveItem
              key={"person-" + item?.id}
              branch_name={item?.branch_name}
              baygani_code={item?.baygani_code}
            />
          ))}
        </ul>
      ) : (
        <p className="text-gray-500">
          {" "}
          هنوز {props.emptyLabel} برای پرونده ثبت نشده است!{" "}
        </p>
      )}
    </div>
  );
};

export default CaseContentInfoBarchive;
